import AppDrawer from "components/Drawers/AppDrawer";
import useUpdatePassword from "api/api-hooks/auth/useUpdatePassword";
import { newToastEvent } from "utils/ToastUtil";
import { useState } from "react";
import { Alert, Badge, Button } from "reactstrap";
import Password from "components/Inputs/Password";
import AppSpinner from "../../../elements/AppSpinner";

const ChangePasswordDrawer = ({ open, account, onClose }) => {
  const { updatePassword, passwordUpdating, updatePasswordError } =
    useUpdatePassword();

  const [password, setPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmation, setConfirmation] = useState("");
  const [clientError, setClientError] = useState(null);

  // const [validOldPassword, setValidOldPassword] = useState(false); // Not validating to allow old users to change their unvalid password
  const [validNewPassword, setValidNewPassword] = useState(false);
  const [validConfirmation, setValidConfirmation] = useState(false);

  // Reset local state before closing drawer.
  const handleClose = () => {
    setPassword("");
    setNewPassword("");
    setConfirmation("");
    setClientError(null);
    onClose();
  };

  const handleCloseDrawer = () => {
    onClose();
    setClientError(null);
  };

  // For when the password is successfully updated.
  const onSuccess = () => {
    handleClose();
    newToastEvent("success", "Successfully updated password");
  };

  const saveNewPassword = () => {
    if (newPassword !== confirmation) {
      return setClientError("The new password and confirmation don't match");
    } else if (clientError) {
      setClientError(null);
    }

    updatePassword({
      accountID: account.id,
      oldPassword: password,
      newPassword: newPassword,
      onSuccess: onSuccess,
    });
  };

  return (
    <AppDrawer
      backdrop="static"
      open={open}
      onClose={handleCloseDrawer}
      headerTitle="Change Password"
      headerOptions={
        <Button
          size="sm"
          color="primary"
          onClick={saveNewPassword}
          disabled={
            !password ||
            !newPassword ||
            !confirmation ||
            !validNewPassword ||
            !validConfirmation ||
            passwordUpdating ||
            newPassword !== confirmation
          }
        >
          {passwordUpdating ? <AppSpinner color="white" /> : "Update Password"}
        </Button>
      }
      body={
        <>
          <h4 className="mb-0 mr-2">Account Email</h4>
          <Badge>{account?.Email}:</Badge>
          <hr className="my-4" />
          <h4>Old Password</h4>
          <Password
            className="mb-4"
            autoComplete="new-password"
            onChange={(e) => setPassword(e.target.value)}
            setClientError={setClientError}
            // setValidPassword={setValidPassword} // Bypass oldpassword validation
            userEmail={account?.Email}
            useError={false}
          />
          <h4>New Password</h4>
          <Password
            className="mb-4"
            autoComplete="new-password"
            onChange={(e) => setNewPassword(e.target.value)}
            setClientError={setClientError}
            setValidPassword={setValidNewPassword}
            userEmail={account?.Email}
          />
          <h4>Confirm New Password</h4>
          <Password
            className="mb-4"
            autoComplete="new-password"
            onChange={(e) => setConfirmation(e.target.value)}
            setClientError={setClientError}
            setValidPassword={setValidConfirmation}
            userEmail={account?.Email}
          />
          {clientError && <Alert color="danger">{clientError}</Alert>}
          {updatePasswordError && (
            <Alert color="danger">{updatePasswordError}</Alert>
          )}
        </>
      }
    />
  );
};

export default ChangePasswordDrawer;
